import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
  attemptSilentAppUpdateReload,
  isAppUpdateReady,
  subscribeToAppUpdateReady,
} from '@/offline/registerServiceWorker';

export function AppUpdateBoundary() {
  const location = useLocation();

  useEffect(() => {
    if (isAppUpdateReady()) {
      attemptSilentAppUpdateReload('route-transition');
    }
  }, [location.key]);

  useEffect(() => {
    return subscribeToAppUpdateReady(() => {
      attemptSilentAppUpdateReload('update-ready');
    });
  }, []);

  return <Outlet />;
}
